import useMemo from "./useMemo";
import useEffect from "./useEffect";
import useCallback from "./useCallback";

export default function useIsMounted(){
	const memory = useMemo({mounted: true});
	useEffect(() => () => memory.mounted = false);
	return useCallback(() => memory.mounted);
}
